export const SOCKET_numberupdate = "SOCKET_numberUpdate"
export const SOCKET_crash = "SOCKET_crash"
export const SOCKET_playing = "SOCKET_playing"
export const SOCKET_startTimer = "SOCKET_startTimer"
export const SOCKET_history = "SOCKET_history"
export const SOCKET_bets = "SOCKET_bets"
export const SOCKET_won = "SOCKET_won"
export const SOCKET_initChat = "SOCKET_initChat"
export const SOCKET_addChat = "SOCKET_chatMessage"
export const SOCKET_timerWaiting = "SOCKET_timerWaiting"
